"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Failed = exports.InUse = exports.Stopped = exports.Prepared = exports.NotSupported = exports.NotRequested = exports.HlsJSGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const hlsjs_1 = require("../../drivers/video-element/hlsjs");
const state_flow_2 = require("../state-flow");
const common_1 = require("./common");
//#endregion
//#region Group Declaration
exports.HlsJSGroup = state_flow_2.PlayerStateFlow.registerGroup("hlsJs").bootstrap(() => {
    return (0, exports.NotRequested)({
        driverFormat: "mp4-hls",
        priority: -1,
        support: "",
        timeout: 0,
        features: {
            sourceQuality: false,
            forcedQuality: true,
            autoBitrate: true,
        },
    });
});
//#endregion
//#region Signals Handlers
function loadDriver(groups, signal) {
    const [priority, config] = (0, common_1.findDriver)(hlsjs_1.HlsJSDriver, signal.options.drivers);
    if (priority === -1) {
        return state_flow_1.Result.ignore();
    }
    const support = (0, common_1.checkDriverSupport)(hlsjs_1.HlsJSDriver, groups.host.element, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.hlsJs, priority, support, timeout: config.timeout, hlsjsConfig: config.hlsjsConfig });
    }
    return (0, exports.NotSupported)({ ...groups.hlsJs, priority, support });
}
function unloadDriver(groups, signal) {
    const [priority, _] = (0, common_1.findDriver)(hlsjs_1.HlsJSDriver, signal.options.drivers);
    if (priority !== -1) {
        return state_flow_1.Result.ignore();
    }
    return (0, exports.NotRequested)({ ...groups.hlsJs, priority });
}
function updateSupportHostStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(hlsjs_1.HlsJSDriver, signal.host, groups.manifest.json);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.hlsJs, support });
    }
    return (0, exports.NotSupported)({ ...groups.hlsJs, support });
}
function updateSupportManifestStatus(groups, signal) {
    const support = (0, common_1.checkDriverSupport)(hlsjs_1.HlsJSDriver, groups.host.element, signal.manifest);
    if (support === "hmp") {
        return (0, exports.Prepared)({ ...groups.hlsJs, support });
    }
    return (0, exports.NotSupported)({ ...groups.hlsJs, support });
}
// function nativeHlsLoad({ nativeHls, manifest }: Groups, signal: Signals["nativeHlsLoad"]): StateResult<Props> {
//   const format = manifest.json?.formats[nativeHls.driverFormat];
//   if (format == null) {
//     return NotSupported({ ...nativeHls });
//   }
//
//   return Loaded({ ...nativeHls });
// }
// function requestDriver({ nativeHls }: Groups, signal: Signals["requestDriver"]): StateResult<Props> {
//   return NotSupported(nativeHls);
// }
//#endregion
//#region States Declarations
exports.NotRequested = exports.HlsJSGroup.registerState("NotRequested", {
    optionsApply: loadDriver,
});
exports.NotSupported = exports.HlsJSGroup.registerState("NotSupported", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
});
exports.Prepared = exports.HlsJSGroup.registerState("Prepared", {
    optionsApply: unloadDriver,
    manifestUpdate: updateSupportManifestStatus,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.HlsJSGroup.name ? (0, exports.InUse)(g.hlsJs) : g.hlsJs;
    },
});
exports.Stopped = exports.HlsJSGroup.registerState("Stopped", {
    optionsApply: unloadDriver,
    hostElementAttach: updateSupportHostStatus,
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.HlsJSGroup.name ? (0, exports.InUse)(g.hlsJs) : g.hlsJs;
    },
});
exports.InUse = exports.HlsJSGroup.registerState("InUse", {
    optionsApply: () => state_flow_1.Result.reject("driver is in use"),
    hostElementDetach: () => state_flow_1.Result.reject("host element is in use of HlsJs"),
    // detachHostElement: (g) => Prepared(g.nativeHls),
    driverSwitch: (g, s) => {
        const res = (0, common_1.checkDriverSwitchRestrictions)(g);
        if (res.kind === state_flow_1.ResultKind.Rejected) {
            return res;
        }
        return s.driver === exports.HlsJSGroup.name ? g.hlsJs : (0, exports.Stopped)(g.hlsJs);
    },
});
exports.Failed = exports.HlsJSGroup.registerState("Failed", {
    optionsApply: unloadDriver,
});
//#endregion
//# sourceMappingURL=hlsjs.js.map